/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonValidatorVoteListRequest = {
    validator?: string;
    statusTypes?: Array<'UNSPECIFIED' | 'DEPOSIT_PERIOD' | 'VOTING_PERIOD' | 'PASSED' | 'REJECTED' | 'FAILED'>;
    vote?: Array<'YES' | 'NO' | 'VETO' | 'ABSTAIN' | 'DID_NOT_VOTE' | 'WEIGHTED'>;
    sortDirection?: BabylonValidatorVoteListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonValidatorVoteListRequest {

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

